import { render, staticRenderFns } from "./Template6.vue?vue&type=template&id=f1b246ac&scoped=true&"
import script from "./Template6.vue?vue&type=script&lang=js&"
export * from "./Template6.vue?vue&type=script&lang=js&"
import style0 from "./Template6.vue?vue&type=style&index=0&id=f1b246ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b246ac",
  null
  
)

export default component.exports